import React from "react";
import { Modal } from "reactstrap";
import ApiService from "../../services/apiService";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
const Motor = ({
  isOpen,
  onClose,
  motorName,
  container,
}: {
  isOpen: boolean;
  onClose: () => void;
  motorName: string;
   style?: React.CSSProperties;
       container?: HTMLElement | null;
}) => {
  const [PumpData, setpumpdata] = useState<any[]>([]);
  const getAllPumpingStations = async () => {
    try {
      const response = await ApiService.axiosApi(`/tags`, {
        method: "GET",
      });

      if (response.success) {
        
        setpumpdata(response.data);
       
      } else {
         console.error("Failed to fetch pumping stations");
      }
    } catch (error) {
      console.error("Error fetching pumping stations:", error);
       console.error("Error fetching pumping stations");
    }
  };

useEffect(() => {
  getAllPumpingStations();

  // Move setInterval inside useEffect
  const interval = setInterval(() => {
    getAllPumpingStations();
  }, 5000); 

  // Cleanup interval on unmount
  return () => clearInterval(interval);
}, []); // keep dependency array


  const motorDisplayNames: { [key: string]: string } = {
    PMP1: "PUMP 1",
    PMP2: "PUMP 2",
    PMP3: "PUMP 3",
    PMP4: "PUMP 4",
    PMP5: "PUMP 5",
  };

 
  return (
    <Modal isOpen={isOpen} size="xl" centered toggle={onClose}
      style={{
        zIndex: 9999, // High z-index
      }}
       container={container || document.body} // Use container prop or fallback to body
        
      modalClassName="custom-modal-class"
        backdropClassName="custom-backdrop-class"
        contentClassName="custom-content-class">
      <div className="modal-motor1 w-100">
        <div className="modal-header-motor1 py-3">
          <h2>{motorDisplayNames[motorName] || motorName}</h2>
          <div className="modal-actions-motor1">
            <button
              className="refreshButtonMotor"
              onClick={getAllPumpingStations}
              style={{ cursor: "pointer" }}
            >
              &#x21bb;
            </button>
            <button className="closeMotor" onClick={onClose}>
              &times;
            </button>
          </div>
        </div>

        <div className="modal-body-motor1">
          <div className="section-motor1 w-100">
            <h3 style={{ color: "white" }}>SYSTEM IN WEB SCADA</h3>
          </div>

          <div className="section-controls-motor1 w-100">
            <div className="status-box-motor1">
              <div
                style={{
                  color: "white",
                  paddingLeft: "4px",
                  fontWeight: "700",
                }}
              >
                ALARM STATUS
              </div>
            </div>
            <div
              style={{ background: "#222", width: "100%", paddingLeft: "4px" }}
            >
              <div style={{ color: "white", paddingLeft: "4px" }}>
                <div
                  className="statusbox-motor1"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) =>
                        t.name === `${motorName}_WIND_HH` && t.value === "True"
                    )
                      ? "red"
                      : "grey",
                  }}
                ></div>{" "}
                Winding Temperature Alarm
              </div>
              <div style={{ color: "white", paddingLeft: "4px" }}>
                <div
                  className="statusbox-motor1"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) =>
                        t.name === `${motorName}_TBH_HH` && t.value === "True"
                    )
                      ? "red"
                      : "grey",
                  }}
                ></div>{" "}
                Thrust Bearing Temperature Alarm
              </div>
            </div>
          </div>

          <div className="section-motor1 w-100">
            <h4 style={{ color: "white" }}>INPUT BREAKER</h4>
            <table className="InputBreakertable-motor1 w-100 table-motor1 ">
              <tr>
                <div>
                  <td style={{ color: "white" }}>
                    <span
                      className="statusbox-motor1"
                      style={{
                        backgroundColor: PumpData.find(
                          (t) =>
                            t.name === `${motorName}_ON` && t.value === "True"
                        )
                          ? "green"
                          : "grey",
                      }}
                    ></span>
                    <span>Breaker On</span>
                  </td>
                </div>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_RMT` && t.value === "True"
                      )
                        ? "green"
                        : "grey",
                    }}
                  ></span>
                  Breaker In Remote
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_TCH` && t.value === "True"
                      )
                        ? "YELLOW"
                        : "grey",
                    }}
                  ></span>
                  Trip Circuit Healthy
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_HLTHY` && t.value === "True"
                      )
                        ? "GREEN"
                        : "grey",
                    }}
                  ></span>
                  Breaker Ready Auto
                </td>
              </tr>
              <tr>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_OFF` && t.value === "True"
                      )
                        ? "red"
                        : "grey",
                    }}
                  ></span>
                  Breaker Off
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_BSP` && t.value === "True"
                      )
                        ? "red"
                        : "grey",
                    }}
                  ></span>
                  Breaker Service Position
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_SCH` && t.value === "True"
                      )
                        ? "green"
                        : "grey",
                    }}
                  ></span>
                  Spring Charge Feedback
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_RDY` && t.value === "True"
                      )
                        ? "green"
                        : "grey",
                    }}
                  ></span>
                  Breaker Ready Manual
                </td>
              </tr>
              <tr>
                <td></td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_TEST` && t.value === "True"
                      )
                        ? "green"
                        : "grey",
                    }}
                  ></span>
                  Breaker Test Position
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_SS_BYPASS` &&
                          t.value === "True"
                      )
                        ? "red"
                        : "grey",
                    }}
                  ></span>
                  Soft Starter Bypass
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_SS_RDY` && t.value === "True"
                      )
                        ? "green"
                        : "grey",
                    }}
                  ></span>
                  Soft Starter Ready
                </td>
              </tr>
            </table>
          </div>

          <div className="section-motor1 w-100">
            <h4 style={{ color: "white" }}>PUMP LOGIC FAULT CONDITION</h4>
            <table className="PumpTable-motor1 w-100 table-motor1">
              <tr>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_ANYFLT` && t.value === "True"
                      )
                        ? "YELLOW"
                        : "grey",
                    }}
                  ></span>
                  Pump Any Fault
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_FBFLT` && t.value === "True"
                      )
                        ? "YELLOW"
                        : "grey",
                    }}
                  ></span>
                  Pump Feedback Fault
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_TRP` && t.value === "True"
                      )
                        ? "YELLOW"
                        : "grey",
                    }}
                  ></span>
                  Breaker Trip
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_WIND_TRP` &&
                          t.value === "True"
                      )
                        ? "YELLOW"
                        : "grey",
                    }}
                  ></span>
                  Winding Temp Trip
                </td>
              </tr>
              <tr>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_PT_TRP` && t.value === "True"
                      )
                        ? "YELLOW"
                        : "grey",
                    }}
                  ></span>
                  Pump PT Trip
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_PT_TRP` && t.value === "True"
                      )
                        ? "YELLOW"
                        : "grey",
                    }}
                  ></span>
                  Headerline PT Trip
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) =>
                          t.name === `${motorName}_TBH_TRP` &&
                          t.value === "True"
                      )
                        ? "YELLOW"
                        : "grey",
                    }}
                  ></span>
                  Thrust Breaking Trip
                </td>
                <td style={{ color: "white" }}>
                  <span
                    className="statusbox-motor1"
                    style={{
                      backgroundColor: PumpData.find(
                        (t) => t.name === "SUMP_LVL_L" && t.value === "True"
                      )
                        ? "red"
                        : "grey",
                    }}
                  ></span>
                  Sump Level Low
                </td>
              </tr>
            </table>
          </div>

          <div className="flex-row-motor1 w-100">
            <div className="section-motor1 half-motor1 w-100">
              <div className="w-100">
                <h4>TEMPERATURE SCANNER</h4>
              </div>
              <table className="TemperatureScanner-motor1">
                <tbody>
                  <tr>
                    <td>R1 PHASE</td>
                    <td>
                      {PumpData.find(
                        (t) => t.name === `${motorName}_TS_TEMP_CH1`
                      )?.value ?? 0}{" "}
                      °C
                    </td>
                  </tr>
                  <tr>
                    <td>R2 PHASE</td>
                    <td>
                      {PumpData.find(
                        (t) => t.name === `${motorName}_TS_TEMP_CH2`
                      )?.value ?? 0}{" "}
                      °C
                    </td>
                  </tr>
                  <tr>
                    <td>Y1 PHASE</td>
                    <td>
                      {PumpData.find(
                        (t) => t.name === `${motorName}_TS_TEMP_CH3`
                      )?.value ?? 0}{" "}
                      °C
                    </td>
                  </tr>
                  <tr>
                    <td>Y2 PHASE</td>
                    <td>
                      {PumpData.find(
                        (t) => t.name === `${motorName}_TS_TEMP_CH4`
                      )?.value ?? 0}{" "}
                      °C
                    </td>
                  </tr>
                  <tr>
                    <td>B1 PHASE</td>
                    <td>
                      {PumpData.find(
                        (t) => t.name === `${motorName}_TS_TEMP_CH5`
                      )?.value ?? 0}{" "}
                      °C
                    </td>
                  </tr>
                  <tr>
                    <td>B2 PHASE</td>
                    <td>
                      {PumpData.find(
                        (t) => t.name === `${motorName}_TS_TEMP_CH6`
                      )?.value ?? 0}{" "}
                      °C
                    </td>
                  </tr>
                  <tr>
                    <td>NDE MOTOR</td>
                    <td>
                      {PumpData.find(
                        (t) => t.name === `${motorName}_TS_TEMP_CH7`
                      )?.value ?? 0}{" "}
                      °C
                    </td>
                  </tr>
                  <tr>
                    <td>DE MOTOR</td>
                    <td>
                      {PumpData.find(
                        (t) => t.name === `${motorName}_TS_TEMP_CH8`
                      )?.value ?? 0}{" "}
                      °C
                    </td>
                  </tr>
                </tbody>
              </table>
              console.log(value);
            </div>
            <div className="section-motor1 half-motor1">
              <h4>ELECTRICAL PARAMETERS</h4>
              <table className="ElectricalParameters-motor1">
                <tr>
                  <td>Voltage Line A-B</td>
                  <td>
                    {PumpData.find((t) => t.name == `${motorName}_Vab`)
                      ?.value ?? 0}
                    V
                  </td>
                </tr>
                <tr>
                  <td>Voltage Line B-C</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_Vbc`)
                      ?.value ?? 0}
                    V
                  </td>
                </tr>
                <tr>
                  <td>Voltage Line C-A</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_Vca`)
                      ?.value ?? 0}
                    V
                  </td>
                </tr>
                <tr>
                  <td>Line Current-A</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_Ia`)?.value ??
                      0}
                    A
                  </td>
                </tr>
                <tr>
                  <td>Line Current-B</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_Ib`)?.value ??
                      0}
                    A
                  </td>
                </tr>
                <tr>
                  <td>Line Current-C</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_Ic`)?.value ??
                      0}
                    A
                  </td>
                </tr>
                <tr>
                  <td>Power Factor</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_PF`)?.value ??
                      0}
                    PF
                  </td>
                </tr>
                <tr>
                  <td>Active Power</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_KW`)?.value ??
                      0}
                    KW
                  </td>
                </tr>
                <tr>
                  <td>Total KWH</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_KWH`)
                      ?.value ?? 0}
                    KWH
                  </td>
                </tr>
                <tr>
                  <td>Daily KWH</td>
                  <td>
                    {PumpData.find((t) => t.name === `${motorName}_KWH_DAY`)
                      ?.value ?? 0}
                    KWH/DAY
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div className="sectionfooter-grid-motor1">
            <span style={{ color: "white" }}>
              RUN HOURS FOR DAY (HH:MM):{" "}
              <strong>
                {PumpData.find((tag) => tag.name === `${motorName}_DLY_RUNMIN`)
                  ?.run_HH_MM ?? 0}
              </strong>
            </span>

            <span className="Run-hour-motor1" style={{ color: "white" }}>
              CUMULATIVE RUN HOURS (HH:MM):{" "}
              <strong>
                {" "}
                {PumpData.find((tag) => tag.name === `${motorName}_RES_RUNHRS`)
                  ?.value ?? 0}
                :
                {PumpData.find((tag) => tag.name === `${motorName}_RES_RUNMIN`)
                  ?.value ?? 0}
              </strong>
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default Motor;
